import { RobotOutlined, UserOutlined } from '@ant-design/icons';
import { FiUsers } from 'react-icons/fi';

export const ASIDE_ELEMENTS = company => {
  const elements = [
    {
      path: '/chat/groups',
      text: 'groups',
      image: <FiUsers />,
      dataQa: 'chatsTab',
    },
    {
      path: '/chat/personal',
      text: 'personal',
      image: <UserOutlined />,
      dataQa: 'personalChatsTab',
    },
  ];

  if (company?.hasBots) {
    elements.push({
      path: '/chat/bots',
      text: 'bots',
      image: <RobotOutlined />,
      dataQa: 'botsChatsTab',
    });
  }

  return elements;
};
